// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-module--wrapper--3wWgs","footerText":"footer-module--footerText--3IwrJ"};